import React from "react";
import {CustomLoading} from "components/CustomLoading";
import "bootstrap/dist/css/bootstrap.min.css";
import toastr from "toastr";
import axios from "axios";
import {KTMScreen} from "ktm-ui";
import PaymentFiles from "./PaymentFiles";
import PolicyFunding from "./PolicyFunding";
import FundingRefund from "./FundingRefund";
import EFTReissue from "./EFTReissue";
import DistroPayments from "./DistroPayments";
import OperationalTransfers from "./OperationalTransfers";
import OperationalReports from "./OperationalReports";
import ChequeDeposit from "./ChequeDeposit";
import TeladocDashboard from "./TeladocDashboard";
import CorehealthDashboard from "./CorehealthDashboard";
import UnfinalizeClaim from "./UnfinalizeClaim";
import PadDashboard from "./PadDashboard";
import {
    DollarSign,
    FileText,
    BookOpen,
    RefreshCw,
    Undo2,
    Wallet,
    Stethoscope,
    HeartPulse,
    ArrowLeftRight,
    BarChart3,
    ShieldX,
    Landmark
} from 'lucide-react';

const allNavItems = [
    { label: "Apply Funding", icon: DollarSign, role: "Finance|FinanceSupport" },
    { label: "PAD", icon: Landmark, role: "Finance" },
    { label: "Payment Files", icon: FileText, role: "Finance|FinanceSupport" },
    { label: "Cheque Deposit", icon: BookOpen, role: "Finance|FinanceSupport" },
    { label: "Reissue EFT", icon: RefreshCw, role: "Finance|FinanceSupport" },
    { label: "Funding Refund", icon: Undo2, role: "Finance|FinanceSupport" },
    { label: "Distro Payments", icon: Wallet, role: "Finance" },
    { label: "Teladoc Dashboard", icon: Stethoscope, role: "Finance" },
    { label: "Corehealth Dashboard", icon: HeartPulse, role: "Finance" },
    { label: "Operational Transfers", icon: ArrowLeftRight, role: "Finance" },
    { label: "Reports", icon: BarChart3, role: "Finance|DataImplementation" },
    { label: "Unfinalize Claim", icon: ShieldX, role: "Finance|FinanceSupport|Adjudicator" },
];

export default KTMScreen(
    {name: "financials"},
    class extends React.Component<any, any> {
        state = {
            loading: true,
            currentListItem: "Apply Funding",
            userRole: null,
        };

        componentDidMount() {
            this.GetFinanceUserRole();
        }

        GetFinanceUserRole() {
            axios.get("/api/PlanAdmin/getfinanceuserrole")
                .then(res => {
                        if (res.data.success) {
                            this.setState({
                                userRole: res.data.userRole,
                                loading: false,
                                currentListItem: this.getDefaultItem(res.data.userRole)
                            });
                        } else {
                            toastr.error(res.data.message, "Error");
                        }
                    }
                )
                .catch(error => {
                    toastr.error(error, "Error");
                });
        }

        getDefaultItem(userRole) {
            if (userRole === "Adjudicator") return "Unfinalize Claim";
            if (userRole === "DataImplementation") return "Reports";
            return "Apply Funding";
        }

        setCurrentItem = (item) => {
            this.setState({currentListItem: item});
        };

        getNavItems() {
            return allNavItems.filter(item => {
                if (!item.role) return true;
                const roles = item.role.split("|");
                return roles.includes(this.state.userRole);
            });
        }

        render() {
            let container = null;
            let contents = null;
            if (this.state.loading) {
                contents = <CustomLoading/>;
            } else {
                if (this.state.currentListItem === "Apply Funding") {
                    contents = <PolicyFunding/>;
                } else if (this.state.currentListItem === "PAD") {
                    contents = <PadDashboard/>;
                } else if (this.state.currentListItem === "Payment Files") {
                    contents = <PaymentFiles/>;
                } else if (this.state.currentListItem === "Cheque Deposit") {
                    contents = <ChequeDeposit/>;
                } else if (this.state.currentListItem === "Reissue EFT") {
                    contents = <EFTReissue/>;
                } else if (this.state.currentListItem === "Funding Refund") {
                    contents = <FundingRefund/>;
                } else if (this.state.currentListItem === "Distro Payments") {
                    contents = <DistroPayments/>;
                } else if (this.state.currentListItem === "Teladoc Dashboard") {
                    contents = <TeladocDashboard/>;
                } else if (this.state.currentListItem === "Corehealth Dashboard") {
                    contents = <CorehealthDashboard/>;
                }  else if (this.state.currentListItem === "Operational Transfers") {
                    contents = <OperationalTransfers/>;
                } else if (this.state.currentListItem === "Reports") {
                    contents = <OperationalReports/>;
                } else if (this.state.currentListItem === "Unfinalize Claim") {
                    contents = <UnfinalizeClaim/>;
                }

                const navItems = this.getNavItems();

                container = (
                    <div className="ktm-reports">
                        <div className="advisor-nav">
                            {navItems.map((item, index) => (
                                <button
                                    key={index}
                                    className={`advisor-nav-item${this.state.currentListItem === item.label ? ' active' : ''}`}
                                    onClick={() => this.setCurrentItem(item.label)}
                                >
                                    <item.icon size={18} />
                                    {item.label}
                                </button>
                            ))}
                        </div>
                        <div className="advisor-content-card">
                            {contents}
                        </div>
                    </div>
                );
            }
            return <div className="advisor-page-container">{container}</div>;
        }
    }
);
